module.exports = "<div *ngIf=\"showMessage\" style=\"padding-top: 10px; font-size: 14px; font-weight: bold;\">\n  <i>No records found...</i>\n</div>\n"